// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highlight {
    font-weight: bold;
    color: black;
  }

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__link:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__highlightString {
  max-width: 100%;
  font-size: 12px;
  color: grey;
  white-space: pre;
  word-break: break-word;
}

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__highlightString > * {
    white-space: pre;
    word-break: break-word;
  }

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__label {
  font-size: 13px;
  font-weight: bold;
  word-break: break-all;
  margin-right: 10px;
  color: #4a4a4a;
  font-weight: bold;
}

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__thumbnail {
  height: 20px;
  max-height: calc(100% - 10px);
  width: 30px;
  max-width: 100%;
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  margin: -5px 10px;
  display: inline-block;
}

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__flagsContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__flag {
  padding: 2px 5px;
  border-radius: 8px;
  line-height: 10px;
  font-size: 10px;
  margin-right: 2px;
}

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__stepLabel {
  padding: 3px 4px;
  border-radius: 8px;
  line-height: 10px;
  border: 1px solid #4a4a4a;
  font-size: 10px;
  margin-right: 10px;
}

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__parentLabel {
  padding: 3px 4px;
  border-radius: 4px;
  line-height: 10px;
  background-color: #4a4a4a;
  color: #ffffff;
  font-size: 10px;
  margin-right: 10px;
  white-space: nowrap;
}

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__status {
  padding: 3px 4px;
  border-radius: 3px;
  line-height: 10px;
  font-size: 10px;
  margin-right: 10px;
}

.app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__projectLabel {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding: 3px 4px;
  line-height: 10px;
  font-size: 10px;
}
`, "",{"version":3,"sources":["webpack://./app/main/Authenticated/Header/SearchingBar/SearchingResults.module.scss"],"names":[],"mappings":"AACE;IACE,iBAAiB;IACjB,YAAY;EACd;;AAGF;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AAKxB;;AAJE;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;AAGF;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[":global {\n  .highlight {\n    font-weight: bold;\n    color: black;\n  }\n}\n\n.link:hover {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n\n.highlightString {\n  max-width: 100%;\n  font-size: 12px;\n  color: grey;\n  white-space: pre;\n  word-break: break-word;\n  > * {\n    white-space: pre;\n    word-break: break-word;\n  }\n}\n\n.label {\n  font-size: 13px;\n  font-weight: bold;\n  word-break: break-all;\n  margin-right: 10px;\n  color: #4a4a4a;\n  font-weight: bold;\n}\n\n.thumbnail {\n  height: 20px;\n  max-height: calc(100% - 10px);\n  width: 30px;\n  max-width: 100%;\n  background-size: cover;\n  background-position: center;\n  border-radius: 5px;\n  margin: -5px 10px;\n  display: inline-block;\n}\n\n.flagsContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.flag {\n  padding: 2px 5px;\n  border-radius: 8px;\n  line-height: 10px;\n  font-size: 10px;\n  margin-right: 2px;\n}\n\n.stepLabel {\n  padding: 3px 4px;\n  border-radius: 8px;\n  line-height: 10px;\n  border: 1px solid #4a4a4a;\n  font-size: 10px;\n  margin-right: 10px;\n}\n\n.parentLabel {\n  padding: 3px 4px;\n  border-radius: 4px;\n  line-height: 10px;\n  background-color: #4a4a4a;\n  color: #ffffff;\n  font-size: 10px;\n  margin-right: 10px;\n  white-space: nowrap;\n}\n\n.status {\n  padding: 3px 4px;\n  border-radius: 3px;\n  line-height: 10px;\n  font-size: 10px;\n  margin-right: 10px;\n}\n\n.projectLabel {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  padding: 3px 4px;\n  line-height: 10px;\n  font-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__link`,
	"highlightString": `app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__highlightString`,
	"label": `app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__label`,
	"thumbnail": `app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__thumbnail`,
	"flagsContainer": `app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__flagsContainer`,
	"flag": `app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__flag`,
	"stepLabel": `app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__stepLabel`,
	"parentLabel": `app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__parentLabel`,
	"status": `app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__status`,
	"projectLabel": `app-main-Authenticated-Header-SearchingBar-___SearchingResults-module__projectLabel`
};
export default ___CSS_LOADER_EXPORT___;
